import React, {Fragment} from 'react';
import "./styles/_skeleton.scss"
import SkeletonHeader from './SkeletonHeader';
import SkeletonLoans from './SkeletonLoans';
import SkeletonAvailable from './SkeletonAvailable';

export default function SkeletonHome() {
  return (
    <Fragment>
        <SkeletonHeader />
        <SkeletonLoans />
        <SkeletonAvailable />
    </Fragment>
  )
}
